import React, { useState } from "react";
import ApiDatabase from "server";
import UseContext from "hooks/useContext";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import PerimeterAccessAlert from "components/modal/dataModal/data/perimeter/PerimeterAccessAlert";
import PerimeterModalFooter from "components/modal/dataModal/data/perimeter/PerimeterModalFooter";
import usePerimeterModal from "components/modal/dataModal/data/perimeter/usePerimeterModal";
import { ARCHIVE_ERROR_OVERRIDES } from "pages/profil/perimeters/perimeterErrors";
import { fillText } from "pages/profil/perimeters/perimeterText";

// A perimeter that never carried a mission: deleted for good.
const DeletePerimeterModal = () => {
    const { language, perimeterModalData } = UseContext();
    const { isSaving, setIsSaving, close, succeed, fail } = usePerimeterModal();
    const [{ perimeter, usage }] = useState(() => perimeterModalData || {});
    const membersLeft = Number(usage?.membersLeftWithoutPerimeter) || 0;

    const handleConfirm = () => {
        if (isSaving) return;
        setIsSaving(true);
        ApiDatabase.deletePerimeter(
            { id: perimeter?.id },
            () => succeed(language.getValue("perimeters.toast.deleted")),
            (err) => fail(err, { overrides: ARCHIVE_ERROR_OVERRIDES })
        );
    };

    return (
        <>
            <Modalheader hide={close} hideShow={true}>
                {fillText(language.getValue("perimeters.delete.title"), {
                    name: perimeter?.name,
                })}
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col gap-4">
                    <p className="text-sm text-gray-600">
                        {language.getValue("perimeters.delete.description")}
                    </p>
                    {membersLeft > 0 && (
                        <PerimeterAccessAlert count={membersLeft} />
                    )}
                </div>
            </ModalBody>
            <PerimeterModalFooter
                confirmLabel={language.getValue("perimeters.delete.confirm")}
                savingLabel={language.getValue("perimeters.delete.deleting")}
                isSaving={isSaving}
                onCancel={close}
                onConfirm={handleConfirm}
            />
        </>
    );
};

export default DeletePerimeterModal;
